import React, { useState, useEffect,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import "../assets/css/styles.table.css"

import {apiUrl} from '../pages/UrlParam';
import AxiosFetchData from '../pages/AxiosFetchData';
 
import Highcharts from 'highcharts';
import ApexChart from 'apexcharts';

import { ColumnDirective, ColumnsDirective, TreeGridComponent } from '@syncfusion/ej2-react-treegrid';
import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective, PdfExport,Selection, Toolbar, Resize } from '@syncfusion/ej2-react-gantt';
import { getMonth, getYear } from 'date-fns';
export const useResourceDashboardHook = () =>{
    const [timelineSetting, setTimelineSetting] = useState({
        timelineUnitSize: 150,
     
          bottomTier: {
         //   timelineUnitSize: 150,
        // count :2,
        count: 1,
          unit: 'Day',
          format: 'MMM dd, yyyy',
          
    }
      });
      const Navigate = useNavigate();
      const [rows, setRows] = useState([]);
      const [rowNumber, setRowNumber] = useState([]);
      const [chart2, setChart2] = useState({});
      const [riskMatrix, setRiskMatrix] = useState({});
      const [projectList, setProjectList] = useState([]);
      const [selectedOptionProject,setSelectedOptionProject] = useState('');
      const [tugasSelesai,setTugasSelesai] = useState('');
      const [tugas,setTugas] = useState('');
      const [milestones,setMilestones] = useState('');
      const [milestonesSelesai,setMilestonesSelesai] = useState('');
      const [tanggalMulai,setTanggalMulai] = useState('');
      const [tanggalSelesai,setTanggalSelesai] = useState('');
      const [status,setStatus] = useState('');
      const [client,setClient] = useState('');
      const [milestonesPemetaan,setMilestonesPemetaan] = useState([]);
      const [tanggal,setTanggal] = useState([]);
      const [bulan,setBulan] = useState([]);
      const [totalColumn,setTotalColumn] = useState([]);
      const [hariKerja,setHariKerja] = useState([]);
      const [totalHariKerja,settotalHariKerja] = useState(0);
      const [engineer,setEngineer] = useState([]);
      const [message,setmessage]= useState('');
      const [chartData, setChartData] = useState([])
      const [pageChart6, setPageChart6] = useState(0)
      const [pageChart3, setPageChart3] = useState(0)
      const [roleAccess, setRoleAccess] = useState('');
      const [dialogopen, setdialogopen] = useState(false);
      const [resourceName, setResourceName] = useState('');
      const [type, setType] = useState('');
      const inputRef =  useRef(null);
     //var arr = [];
    useEffect(() => {
        axios.get(`${apiUrl}/api/GetResource`)
        .then((response) => {
          const transformedOptions = response.data.map((item) => ({
            label: `${item.nama_client}`,
            value: item.id,
          }));
          setProjectList(transformedOptions);
          //setSelectedOptionProject(transformedOptions[0].value);
        //  alert(transformedOptions[0].value)
         // GetData(transformedOptions[0].value);
         GetData(1)
        // GetHariKerja(2018);
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
    
        var tggl = [];
        for(var i=1; i <= 31; i++){
            tggl.push(i);
        }
    
        var bln = [];
        for(var i=1; i <= 12; i++){
            bln.push(i);
        }
    
        setTanggal([...tanggal,tggl]);
        setBulan([...bulan,bln]);
    
    
       // document.getElementById("btnRefresh").click();
    }, []);
    
    const getBulan = () =>{
        var bln = [];
        for(var i=1; i <= 12; i++){
            bln.push(i);
        }
        return bln;
    }
     
    function handleDynamicAction(e,row){
      console.log(row)
    }
     
    const GetChart1 = (data) => {
      
      var dataTask = data.map((item) => item.totaltask);
      var dataProject = data.map((item) => item.totalproject);
      var name = data.map((item) => item.nama_client)
      var options = {
        series: [{
        name: 'Project',
        data: dataProject
      }, {
        name: 'Task',
        data: dataTask
      }],
        chart: {
        type: 'bar',
        height: 280,
        events: {
        
          click: function(event, chartContext, opts) {
            console.log(opts)
              const data = async (data) =>{
                var id = data.globals.labels[data.dataPointIndex].split(' --- ')[0]
                var type = data.globals.seriesNames[data.seriesIndex]
                setType(type)
                setResourceName(data.globals.labels[data.dataPointIndex].split(' --- ')[1].trim())
                
                if(type === "Project"){
                  const response = await AxiosFetchData.get(`GetProjectByResource/${id}`).refreshToken();
                 
                  setRows(response.data.map(function(item,index) {  
                    return {
                      rowNumber: index + 1,
                      ...item
                      
                    }
                  }))
                }
    
                if(type === "Task"){
                  var list = [];
                  var response = await AxiosFetchData.get(`GetProjectByResourceId/${id}`).refreshToken();
                  console.log(response)
                  if(response.data.length > 0){
                    for(var i = 0; i < response.data.length; i++){
                        var response2= await AxiosFetchData.get(`GetTaskList/${response.data[i].id_project}/${id}`).refreshToken();
                        if(response2.data.length > 0){
                          var data = {
                            expanded: true,
                            id: Math.random(),
                            kemajuan: 0,
                            levelname: null,
                            name: response.data[i].nama_project  + " (PROJECT)",
                            prioritasname: null,
                            project_id: null,
                            resource_id: null,
                            sebenarnya_mulai: null,
                            sebenarnya_selesai: null,
                            seq: i,
                            statusname: null,
                            isMilesTone : "",
                            subChild : response2.data
    
                          }
                          list.push(data);
                        }
                    }
                    
                    setRows(list)
                  }
                  
                }
              
    
                setdialogopen(true);
           }
           if(opts.dataPointIndex != -1){
            data(opts);
           }
          
          // alert(opts.dataPointIndex)
           //if(opts.globals.labels[opts.dataPointIndex].split(' --- ')[0] !== 'undefined') {
           // data();
            
           // }
            //data();
            
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories:name,
      },
      yaxis: {
        // title: {
        //   text: '$ (thousands)'
        // }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return  + val  
          }
        }
      }
      }
    
      document.querySelector("#chart6").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart6"), options);
      chart.render();
    
    }
    
    const GetChart2 = (data) => {
      Highcharts.chart('chart2', {
        chart: {
            type: 'pie',
            height: 280,
           // width: 100
            custom: {},
            events: {
                render() {
                    const chart = this,
                        series = chart.series[0];
                    let customLabel = chart.options.chart.custom.label;
                  //  const proses = data.data.chart1.find((o) => o.s)
                    const sum = data.reduce((acc, o) => acc + parseInt(o.y), 0);
                     
                    if (!customLabel) {
                        customLabel = chart.options.chart.custom.label =
                            // chart.renderer.label(data.data.taskProses + ' Dari '  +
                            //      data.data.taskCount + ' Tugas<br/>' + ' Dalam Proses'
                            // )
                            chart.renderer.label( 
                              sum + ' Tugas<br/>'  
                         )
                                .css({
                                    color: '#000',
                                    textAnchor: 'middle',
                                    fontSize: '8px',
                                })
                                .add();
                    }
    
                    const x = series.center[0] + chart.plotLeft,
                        y = series.center[1] + chart.plotTop -
                        (customLabel.attr('height') / 2);
    
                    customLabel.attr({
                        x,
                        y
                    });
                    // Set font size based on chart diameter
                    customLabel.css({
                        fontSize: `${series.center[2] / 12}px`
                    });
                }
            }
        },
        // accessibility: {
        //     point: {
        //         valueSuffix: '%'
        //     }
        // },
        title: {
            text: null
        },
        
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 8,
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -15,
                    //format: '{point.percentage:.0f}%',
                     format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
         //   name: 'Registrations',
            colorByPoint: true,
            innerSize: '75%',
            data:data
        }]
    });
    }
    
    const GetChart3 = (data) => {
      var name = data.map((item) => item.milestone_tugas);
      var data =data.map((item) => item.kemajuan);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 250,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            //borderRadiusApplication: 'end',
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart3").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart3"), options);
        chart.render();
    }
    
    const GetChart4 = (data) => {
        var name =['JAM RENCANA','JAM TERPAKAI']
        var data = [data.jam_rencana,data.jam_sebenernya]
    
        var options = {
            series: [{
            data: data
          }],
            chart: {
            type: 'bar',
            height: 250,
            width: "100%",
            toolbar: {
                show: false
              }
          },
          plotOptions: {
            bar: {
              borderRadius: 2,
              //borderRadiusApplication: 'end',
              horizontal: false,
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: name,
          }
          };
          document.querySelector("#chart4").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart4"), options);
          chart.render();
     }
    
     const GetChart5 = (data) => {
        var dataTask = data.filter(({ task }) => task === "task").map((item) => item.counts);
        var dataRisk = data.filter(({ task }) => task === "risk").map((item) => item.counts);
       // console.log(dataRisk);
    
        var namaKaryawan = data.filter(({ task }) => task === "risk").map((item) => item.nama_client);
        var options = {
            series: [{
            name: 'Tugas',
            data: dataTask
          }, {
            name: 'Resiko',
            data: dataRisk
          }],
            chart: {
            type: 'bar',
            height: 250,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: namaKaryawan,
          },
          yaxis: {
            title: {
             // text: '$ (thousands)'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val
              }
            }
          }
          };
          document.querySelector("#chart5").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart5"), options);
          chart.render();
     }
    
     const GetChart6 = (data) => {
      var name = data.map((item) => item.milestone_tugas);
      var data =data.map((item) => item.kemajuan);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 250,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            //borderRadiusApplication: 'end',
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: name,
        }
        };
    
        document.querySelector("#chart6").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart6"), options);
        chart.render();
    }
    
    const GetChart7 = (data)  =>{
      console.log(data)
      var options = {
        series: [
        {
          data: data
        }
      ],
        chart: {
            height: 250,
            width:"100%",
            type: 'rangeBar',
            toolbar: {
                show: true,
                tools:{
                  download:false // <== line to add
                }
              }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
            hideOverflowingLabels: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          var label = opts.w.globals.labels[opts.dataPointIndex]
         // var a = moment(val[0])
         // var b = moment(val[1])
         // var diff = b.diff(a, 'days')
         // return label + ': ' + diff + (diff > 1 ? ' days' : ' day')
          return label
        },
        style: {
          colors: ['#f3f4f5', '#fff']
        }
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        show: true
      },
      grid: {
        row: {
          colors: ['#f3f4f5', '#fff'],
          opacity: 1
        }
      }
      };
    
      document.querySelector("#chart7").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart7"), options);
      chart.render();
    
         // document.querySelector("#chart7").innerHTML = "";
        // var chart = new ApexChart(document.querySelector("#chart7"), options);
         // chart.render();
    }
    
    const GetChart8 = (data)  =>{
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.data);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 250,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            //borderRadiusApplication: 'end',
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart8").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart8"), options);
        chart.render();
    
    }
    
    const GetChart9 = (data)  =>{
      Highcharts.chart('chart9', {
        chart: {
            type: 'pie',
            height: 200,
            width: 300,
            custom: {},
            events: {
                render() {
                    const chart = this,
                        series = chart.series[0];
                    let customLabel = chart.options.chart.custom.label;
                  //  const proses = data.data.chart1.find((o) => o.s)
                     const sum = data.reduce((acc, o) => acc + parseInt(o.y), 0);
    
                    if (!customLabel) {
                        customLabel = chart.options.chart.custom.label =
                            chart.renderer.label('Total Risiko/Isu' + '<br/>' +  sum)
                                .css({
                                    color: '#000',
                                    textAnchor: 'middle',
                                    fontSize: '8px',
                                })
                                .add();
                    }
    
                    const x = series.center[0] + chart.plotLeft,
                        y = series.center[1] + chart.plotTop -
                        (customLabel.attr('height') / 2);
    
                    customLabel.attr({
                        x,
                        y
                    });
                    // Set font size based on chart diameter
                    customLabel.css({
                        fontSize: `${series.center[2] / 12}px`
                    });
                }
            }
        },
        // accessibility: {
        //     point: {
        //         valueSuffix: '%'
        //     }
        // },
        title: {
            text: null
        },
    
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 8,
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -15,
                    //format: '{point.percentage:.0f}%',
                     format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
         //   name: 'Registrations',
            colorByPoint: true,
            innerSize: '75%',
            data:data
        }]
    });
    }
    
    const GetChart10 = (data) => {
    
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.counts);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 200,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart10").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart10"), options);
        chart.render();
    }
    
    const GetChart11 = (data) => {
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.counts);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 200,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            //horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart11").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart11"), options);
        chart.render();
    }
    
    const GetChart12 = (data)  =>{
      var jamRencana = data.map((item) => item.jam_rencana);
      var jamSebenranya = data.map((item) => item.jam_sebenernya);
      var namaProjek = data.map((item) => item.nama_project);
    
      var options = {
          series: [{
              name: 'Tugas',
              data: jamRencana
          }, {
              name: 'Jam Rencana',
              data: jamSebenranya
          }],
          chart: {
          type: 'bar',
          height: 280,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last', // 'all', 'last'
            dataLabels: {
              total: {
                enabled: false, //
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        xaxis: {
         // type: 'datetime',
          categories: namaProjek,
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
        };
    
        document.querySelector("#chart12").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart12"), options);
        chart.render();
    }
    
    const GetChart13 = (data)  =>{
        var pengeluaran = data.map((item) => item.data);
    
        var namaProjek = data.map((item) => item.name);
    
        var options = {
            series: [{
                name: 'Resiko',
                data: pengeluaran
            } ],
            chart: {
            type: 'bar',
            height: 300,
            stacked: true,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: 'end', // 'around', 'end'
              borderRadiusWhenStacked: 'last', // 'all', 'last'
              dataLabels: {
                total: {
                  enabled: true, // //
                  style: {
                    fontSize: '13px',
                    fontWeight: 900
                  }
                }
              }
            },
          },
          xaxis: {
           // type: 'datetime',
            categories: namaProjek,
          },
          legend: {
            position: 'right',
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
          };
    
         // document.querySelector("#chart13").innerHTML = "";
         // var chart = new ApexChart(document.querySelector("#chart13"), options);
         // chart.render();
    }
    
    const GetData = async (id) => {
      try{
        var response = await AxiosFetchData.get(`GetData3/${id}`,"").refreshToken(Navigate,"engineerdashboard");
        if(response){
          setRoleAccess(response.roleaccess)
         setChartData(response.data);
         var temp1 = [...response.data.chart1]
        // console.log(temp1.splice(pageChart6,1))
         GetChart1(temp1.splice(pageChart6,10))
         //GetChart1(response.data.chart1);
         setEngineer(response.data.engineer)
         GetChart2(response.data.chart2)
    
         var temp2 = [...response.data.chart3]
         GetChart3(temp2.splice(pageChart3,10))
        
        // GetChart3(response.data.chart3)
        } 
      }catch(err){
        setmessage(err.message)
      }
     
    }
       
      function getCellData(bulan,tanggal){
        if(milestonesPemetaan.length > 0){
            var result = milestonesPemetaan.find((obj) => obj.bulan == bulan).data.find((obj) => obj.tanggal==tanggal) ;
            if(typeof(result) != 'undefined')
            {
               
                return result.value
            }
     
            return "";
       }
       
    }
    
    var Total=0;
    function GetRowTotal(tanggal){
        var count = 0;
        for(var i = 0; i < milestonesPemetaan.length; i++){
            var result = milestonesPemetaan[i].data.find((obj) => obj.tanggal==tanggal) ;
            if(typeof(result) != 'undefined'){
                count += milestonesPemetaan[i].data.find((obj) => obj.tanggal== tanggal).value;
            }
           
        }
        Total += count
        return count;
    }
    
    function GetColumnTotal(bulan){
        var count = 0;
      //  milestonesPemetaan[i].data
        var result = milestonesPemetaan.find((obj) => obj.bulan == bulan)
        if(typeof(result) != 'undefined'){
            for(var i = 0; i < milestonesPemetaan.find((obj) => obj.bulan == bulan).data.length; i++){
                // var result = milestonesPemetaan[i].data.find((obj) => obj.tanggal==tanggal) ;
                // if(typeof(result) != 'undefined'){
                     count += milestonesPemetaan.find((obj) => obj.bulan == bulan).data[i].value;
                // }
                
             }
        }
        
        return count;
    }
    
    function  GetTotalDayInMonth(year, month){
        const getDays = (year, month) => new Date(month, month, 0).getDate()
     
        const days = getDays(year, month);
         
        return days
    }
    
    
    async function GetHariKerja(year){
        var getbulan = getBulan();
        var data = [];
        var Total = 0;
        for(var i = 0; i < getbulan.length; i++) {
            var days = GetTotalDayInMonth(year, getbulan[i]);
            
            var response = await AxiosFetchData.get(`GetCountAvailableDay/${days}/${getbulan[i]}/${year}`).refreshToken(Navigate);
            if(response){
                //console.log(response)
                var subdata ={
                    bulan :getbulan[i],
                    days : response.data
                }
                Total += response.data;
                data.push(subdata);
           
              
            }
        }
        setHariKerja(data);
        settotalHariKerja(Total);
       //console.log(data)
    }
     
    function AddProjectData() {
    
    Navigate('/AddProject');
    
    }
     
    const handleSelectedProject = (id) => {
        setSelectedOptionProject(id);
        GetData(id);
    }
    
      
    function GetMonth(date){
      const d = new Date(date);
      let month = d.getMonth();
      return month;
    }
    
    function GetYear(date){
      const d = new Date(date);
      let year = d.getFullYear();
      return year;
    }
    
    const Chart6Paging =   (pageNumber) => {
      if(pageNumber < 0){
          return;
      } 
       
      var temp = [...chartData.chart1];
      
      if((pageNumber * 10) >= temp.length){
        return;
      }
       
      setPageChart6(pageNumber)
    //  console.log(temp.splice((pageNumber * 1)  , 1))
    GetChart1(temp.splice((pageNumber * 10)  , 10));
       
    }
    
    const Chart3Paging =   (pageNumber) => {
      if(pageNumber < 0){
          return;
      }
      
      var temp = [...chartData.chart3.toSorted()];
      
      if((pageNumber * 10) >= temp.length){
        return;
      }
       
      setPageChart3(pageNumber)
      
      GetChart3(temp.splice((pageNumber * 10)  , 10));
       
    }
    
    const columns = [
      { field: 'rowNumber', headerName: 'No', width: 80 },
      { field: 'nama_project', headerName: 'Project Name', width: 250 },
    ];
    
    function handlerowsId(row){
        return row.id;
    }
    
    const settings = { wrapMode: 'Content' };
    
    const content0 = () => {
      return  (
        <div style={{marginTop:10}}>
        <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='100%' enableCollapseAll={false} allowTextWrap={true} textWrapSettings={settings}>
        <ColumnsDirective>
            <ColumnDirective field='id' headerText='Task ID' width='50' textAlign='Right' isPrimaryKey={true} visible={false}/>
            <ColumnDirective field='name' headerText='Task Name' width='250'/>
            <ColumnDirective field='sebenarnya_mulai' headerText='Start Date' width='130' format='yMd' textAlign='Right' />
            <ColumnDirective field='sebenarnya_selesai' headerText='End Date' width='130' format='yMd'  textAlign='Right' />
            <ColumnDirective field='statusname' headerText='Task Status' width='130'  textAlign='Right' />
        </ColumnsDirective>
        </TreeGridComponent>
        </div>
      )
    }
    const content1 = () => {
      return(
      <>
     <div style={{marginTop:10, width:"50%"}}>
                            <button type='button' onClick={() => handleTimeline("month")} className='btn btn-primary' style={{width:150}}>Month</button>&nbsp; 
                            <button type='button' onClick={() => handleTimeline("week")} className='btn btn-primary' style={{width:150}}>Week</button>&nbsp; 
                            <button type='button' id='btnDay' ref={inputRef} onClick={() => handleTimeline("day")} className='btn btn-primary' style={{width:150}}>Day</button> &nbsp;
                            </div>
                            <GanttComponent dataSource={rows} treeColumnIndex={1} height="100%" taskFields={taskFields} allowResizing={true} labelSettings={labelSettings}  timelineSettings={timelineSetting} includeWeekend={false} highlightWeekends={true} workWeek={["Monday", "Tuesday", "Wednesday","Thursday","Friday"]}   toolbar={toolbarOptions} allowPdfExport={true} toolbarClick={toolbarClick}  ref={gantt => ganttChart = gantt}>
                      <ColumnsDirective>
                          <ColumnDirective field='id' width='0' visible={false} />
                          <ColumnDirective field='name' headerText='Task Name'  width='200'/>
                          <ColumnDirective field='sebenarnya_mulai' headerText='Start Date' format={{ type:'date', format:'dd/MM/yyyy' }}/>
                          <ColumnDirective field='sebenarnya_selesai' headerText='End Date' format={{ type:'date', format:'dd/MM/yyyy' }} />
                          <ColumnDirective field='kemajuan' headerText='Progress'/>
                          <ColumnDirective field='statusname' headerText='Status'/>
                      </ColumnsDirective>
                      {/* <HolidaysDirective>
                      <HolidayDirective from='10/14/2024' label='Local Holiday' cssClass='e-custom-holiday'></HolidayDirective>
                          </HolidaysDirective> */}
                              <Inject services={[DayMarkers,Toolbar, PdfExport, Selection,Resize]} />
                      </GanttComponent>
      </>
      )
    }
    
    let headerText = [{ text: "TASK" }, { text: "GANTT" }, { text: "WhatsApp" }];
    
    const taskFields = {
      id: 'id',
      name: 'name',
      startDate: 'sebenarnya_mulai',
      endDate: 'sebenarnya_selesai',
      progress: 'kemajuan',
      child: 'subChild',
    };
    
    const labelSettings = {
      //  leftLabel: 'id',
        rightLabel: '${taskData.name} ${taskData.isMilesTone}',
        taskLabel: '${kemajuan}%'
      };
    
      const toolbarOptions = ['PdfExport'];
    
      let ganttChart;
        function toolbarClick(args) {
         
          if (args.item.text === 'PDF export') {
            var exportProperties= {
              theme:"Material",
              fontFamily: 1,
             // exportType: 'CurrentViewData',
              pageSize: 'A1',
              
              fileName : "TASKDOC.pdf"      
            };
            
              ganttChart.pdfExport(exportProperties);
           }
       };
    
       function handleTimeline(tipe){
        if(tipe=="month"){
            const timelineSettings = {
                timelineUnitSize: 150,
                bottomTier: {
                unit: 'Month',
                 
            }
              };
              setTimelineSetting(timelineSettings)
        }else if(tipe=="week"){
         
            const timelineSettings = {
              timelineUnitSize: 150,
            bottomTier: {
             
                unit: 'Week',
                format: 'MMM dd, yyyy',
              }
              };
              setTimelineSetting(timelineSettings)
        }else{
        
            const timelineSettings = {
                timelineUnitSize: 100,
             
                  bottomTier: {
                    unit: 'Day',
                    format: 'MMM dd, yyyy',
                  
                  }
              };
              setTimelineSetting(timelineSettings)
        }
    
    }

    return {Chart6Paging,pageChart6,projectList,handleSelectedProject,selectedOptionProject,engineer,getMonth,getYear,
            Chart3Paging,pageChart3,dialogopen,setdialogopen,resourceName,type,columns,rows,roleAccess,handleDynamicAction,
            handleTimeline,headerText,content0,content1,GetMonth,GetYear
    }
}